import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const SiteFooter = () => {
  return (
    <footer className="border-t border-[rgba(201,168,76,0.12)] bg-[hsl(166,25%,10%)]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <Link
              to="/"
              className="font-['Cormorant_Garamond'] text-xl font-bold text-[hsl(var(--foreground))]"
            >
              THE COSMIC SYNTHESIST
            </Link>
            <p className="mt-4 font-['Inter'] text-sm leading-relaxed text-[hsl(var(--muted-foreground))]">
              Consciousness, structured. Developing frameworks for understanding identity, power, and the architecture of the self.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-['Inter'] text-xs font-medium uppercase tracking-[0.14em] text-[hsl(var(--silver))] mb-6">
              Navigate
            </h4>
            <nav className="flex flex-col gap-3">
              {[
                { href: '/foundations', label: 'Foundations' },
                { href: '/guidance', label: 'Guidance' },
                { href: '/instruments', label: 'Instruments' },
                { href: '/sacred-feminine-quiz', label: 'Archetype Quiz' },
                { href: '/about', label: 'About' },
                { href: '/contact', label: 'Contact' },
              ].map(link => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="font-['Inter'] text-sm text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))] transition-colors duration-300 flex items-center gap-2 group"
                >
                  <ArrowRight className="h-3 w-3 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 text-[hsl(var(--gold))]" />
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Observatory */}
          <div>
            <h4 className="font-['Inter'] text-xs font-medium uppercase tracking-[0.14em] text-[hsl(var(--silver))] mb-6">
              The Observatory
            </h4>
            <p className="font-['Inter'] text-sm text-[hsl(var(--muted-foreground))] mb-4">
              Receive structured transmissions on consciousness, identity, and the architecture of power.
            </p>
            <Link
              to="/essays"
              className="inline-flex items-center gap-2 font-['Inter'] text-sm text-[hsl(var(--gold))] hover:text-[hsl(var(--champagne))] transition-colors duration-300"
            >
              Read the essays
              <ArrowRight className="h-3.5 w-3.5" />
            </Link>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[rgba(201,168,76,0.08)] flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="font-['Inter'] text-xs text-[hsl(var(--muted-foreground))]">
            &copy; {new Date().getFullYear()} The Cosmic Synthesist. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/privacy"
              className="font-['Inter'] text-xs text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--silver))] transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/cookies"
              className="font-['Inter'] text-xs text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--silver))] transition-colors"
            >
              Cookies Policy
            </Link>
            <Link
              to="/terms"
              className="font-['Inter'] text-xs text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--silver))] transition-colors"
            >
              Terms of Service
            </Link>
            <Link
              to="/admin/login"
              className="font-['Inter'] text-xs text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--silver))] transition-colors"
            >
              Admin Portal
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
